import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

i18n
  .use(initReactI18next)
  .init({
    lng: 'ja',
    fallbackLng: 'ja',
    defaultNS: 'home',
    ns: ['home'],
    resources: messages,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;